"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSharedQuerySelector = exports.sharedQuerySelector = void 0;
const ramda_1 = require("ramda");
const effector_react_1 = require("effector-react");
const store_1 = require("./store");
const sharedQuerySelector = (state, queryKey) => {
    const queryHash = queryKey.join('');
    return (0, ramda_1.path)([queryHash], state);
};
exports.sharedQuerySelector = sharedQuerySelector;
const useSharedQuerySelector = (queryKey) => (0, effector_react_1.useStoreMap)(store_1.$sharedQueries, (store) => (0, exports.sharedQuerySelector)(store, queryKey));
exports.useSharedQuerySelector = useSharedQuerySelector;
